<template>
    <div class="buyflow-panel">
        <div class="flex
                    flex-row
                    justify-between
                    items-center
                    gap-4">
            <div class="text-lg
                        font-bold">
                No, thanks, I don't want to add Home Phone.
            </div>
            <AppModal v-if="isOhio && hasSelectedProInstall === true && meta.customerState !== 'moving'"
                      modal-type="info">
                <template #trigger>
                    <button type="button"
                            class="buyflow-button"
                            :disabled="hasDeclined">
                        <template v-if="hasDeclined">
                            Declined
                        </template>
                        <template v-else>
                            Decline Home Phone
                        </template>
                    </button>
                </template>
                <template #contents>
                    <div class="text-base
                                font-bold
                                mb-2">
                        By Declining Home Phone you will be changing your install option to Self Install
                    </div>
                    <div class="text-sm
                                mt-3
                                font-normal">
                        The benefits of Self Install:
                        <div class="mt-1">
                            <IconCheck class="inline mr-1" /> Contact free way to save money and get set up and connected fast
                        </div>
                        <div>
                            <IconCheck class="inline mr-1" /> Self-Installation Kit is easy to use and is delivered directly to your door (no one is required to be home when your kit is delivered)
                        </div>
                        <div>
                            <IconCheck class="inline mr-1" /> A Certified Tech will call you in advance of the delivery
                        </div>
                    </div>
                </template>
                <template #confirm>
                    <button type="button"
                            class="buyflow-button mt-5"
                            :disabled="hasDeclined"
                            @click.prevent="$emit('decline')">
                        Confirm Selection
                    </button>
                </template>
            </AppModal>
            <button v-else type="button"
                    :disabled="hasDeclined"
                    class="buyflow-button"
                    @click="$emit('decline')">
                <template v-if="hasDeclined">
                    Declined
                </template>
                <template v-else>
                    <span data-cy="decline-voice">
                        Decline Home Phone
                    </span>
                </template>
            </button>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
    import AppModal from "../AppModal";
    import IconCheck from "@/atoms/icons/IconCheck"

    export default {
        name: 'VoiceDeclineService',
        components: {
            AppModal,
            IconCheck,
        },
        props: {
            hasDeclined: {
                type: Boolean,
                required: true,
            },
            selfInstall: {
                type: Object,
                required: false,
            },
            hasSelectedProInstall: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapState([
                'meta',
            ]),
            ...mapGetters('Buyflow', [
                'isOhio',
            ]),
        },
    }
</script>
